import { matchingEngineApi } from '../matching-engine.utils';
import { UseMutationOptions, useQueryClient } from 'react-query';
import { useMutation } from 'common/hooks';

export const useDeleteSkillFeedback = (
  profileId: string,
  skillId: string,
  options: UseMutationOptions = {},
) => {
  const queryClient = useQueryClient();
  const deleteFeedbacks = (feedbackId: string) => {
    return matchingEngineApi.delete(`delete-skill-feedback/${feedbackId}`, {
      params: {
        profileId,
        skillId,
      },
    });
  };

  return useMutation(deleteFeedbacks, {
    onSuccess: (data: any, variables: any) => {
      queryClient.invalidateQueries({
        queryKey: ['pastSkillFeedbacks', variables.revieweeId, variables.skillId],
      });

      queryClient.invalidateQueries({
        predicate: (query) => {
          const queryKey = query.queryKey as any[];
          return queryKey[1] === 'reportees-profiles';
        },
      });

      options.onSuccess?.(data, variables, undefined);
    },
    showSuccessSnackbar: true,
    ...options,
  });
};
